// blog23.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import "../allcss/blog18.css";
import blogImage from "../Asets/Blog.jpg"; // hero background
import detailImg from "../Asets/blog2323.png"; // detail image for blog 23
import Header from "../components/header";
import Footer from "../components/footer";

const Blog23 = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div className="blog-section">
        {/* Hero Section */}
        <div
          className="blog-hero"
          style={{ backgroundImage: `url(${blogImage})` }}
        >
          <div className="blog-overlay">
            <h1 className="blog-title">Our Blog</h1>
            <p className="breadcrumb">
              <span
                style={{ cursor: "pointer", color: "#fff" }}
                onClick={() => navigate("/")}
              >
                Home
              </span>
              <span> / Our Blog / Parent Involvement in Preschool</span>
            </p>
          </div>
        </div>

        {/* Blog Detail */}
        <div className="blog-container">
          <h2 className="section-title">
            Parent Involvement in Preschool: How Red School House Bridges Home and School | Best Preschool in Harni, Vadodara
          </h2>
          <br />
          <div className="published-badge">Published on: 15 November 2025</div>
          <br />

          <img
            src={detailImg}
            alt="Parent Involvement in Preschool | Best Preschool in Harni, Vadodara"
            className="blog-detail-img"
          />

          <div className="blog-detail-content">

            <p>
              A child’s early education becomes stronger when parents and teachers work together. 
              Preschool is not just a place where learning happens — it’s the beginning of a meaningful partnership between home and school. 
              At <strong>Red School House Vadodara</strong>, known as the 
              <strong> best preschool in Harni, Vadodara</strong>, parent involvement is a key part of our learning environment.
            </p>

            <p>
              When parents actively participate in their child’s preschool journey, children feel more confident, secure, and motivated to learn. 
              This creates a powerful foundation for emotional, social, and academic success.
            </p>

            <hr />

            <h3>Why Parent Involvement Matters</h3>
            <p>Parents are a child’s first teachers. When schools and families come together, children benefit in many ways:</p>

            <ul>
              <li>Better learning outcomes</li>
              <li>Stronger emotional development</li>
              <li>More confidence and social skills</li>
              <li>A smoother transition between home and school</li>
            </ul>

            <p>
              At Red School House Vadodara, we ensure parents stay connected, engaged, and informed throughout the year.
            </p>

            <hr />

            <h3>How Red School House Bridges Home and School</h3>

            <h4>1. Regular Communication With Parents</h4>
            <p>Clear communication builds trust. Teachers share regular updates through:</p>
            <ul>
              <li>Daily notes</li>
              <li>Progress reports</li>
              <li>Parent-teacher meetings</li>
              <li>Digital communication</li>
            </ul>
            <p>
              This helps parents understand what their child is learning every day.
            </p>

            <h4>2. Involving Parents in Classroom Activities</h4>
            <p>
              Parents participate in special events, celebrations, storytelling sessions, and activity days.
              Children feel excited and proud when parents join their learning journey.
            </p>

            <h4>3. Transparent Teaching Approach</h4>
            <p>
              Teachers explain classroom routines, teaching methods, and developmental goals. 
              This builds confidence and trust between parents and the school.
            </p>

            <h4>4. Supporting Learning at Home</h4>
            <p>
              Teachers share simple activities parents can do at home — reading, drawing, conversation games, and more. 
              This ensures learning continues outside the classroom.
            </p>

            <h4>5. Creating a Comfortable & Welcoming Environment</h4>
            <p>
              Parents feel welcomed and valued at Red School House Vadodara. 
              Our open-door culture encourages free communication between teachers and families.
            </p>

            <hr />

            <h3>Benefits for Children When Parents Stay Involved</h3>
            <p>Children experience:</p>

            <ul>
              <li>Higher confidence</li>
              <li>Better communication and behavior</li>
              <li>Faster learning progress</li>
              <li>Strong emotional bonding</li>
              <li>More motivation to try new things</li>
            </ul>

            <p>
              This partnership ensures children grow academically, emotionally, and socially.
            </p>

            <hr />

            <h3>Why Red School House Vadodara Is the Best Preschool in Harni, Vadodara</h3>
            <ul>
              <li>Strong parent–teacher coordination</li>
              <li>Safe and nurturing learning environment</li>
              <li>Activity-based and joyful teaching methods</li>
              <li>Transparent communication system</li>
              <li>Focus on holistic development</li>
            </ul>

            <p>
              This combination creates a meaningful learning journey for every child.
            </p>

            <hr />

            <h3>Contact Details</h3>
            <p>
              📍 <strong>Address:</strong> A-25, Castle White, Opp. Main Harni Water Tank, Harni Sama Link Road, Vadodara – 390008
              <br />
              📞 <strong>Phone:</strong> <a href="tel:+917778851070">+91 77788 51070</a>
              <br />
              📧 <strong>Email:</strong>{" "}
              <a href="mailto:redschoolhousebaroda2025@gmail.com">redschoolhousebaroda2025@gmail.com</a>{" "}
              | <a href="mailto:redschoolhousebaroda@gmail.com">redschoolhousebaroda@gmail.com</a>
              <br />
              🌐 <strong>Website:</strong>{" "}
              <a
                href="https://redhouseschoolvadodara.in/"
                target="_blank"
                rel="noreferrer"
              >
                redhouseschoolvadodara.in
              </a>
            </p>

            <p className="blog-tags">
              #RedSchoolHouseVadodara &nbsp; #BestPreschoolInHarni &nbsp; #ParentInvolvement &nbsp; #EarlyChildhoodEducation &nbsp; #VadodaraSchools
            </p>

            {/* Back Button */}
            <div className="back-to-blogs-btn-wrapper">
              <button
                className="back-to-blogs-btn"
                onClick={() => navigate("/blog")}
              >
                Go Back To Blogs
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Blog23;
